<template>
  <div id="bookmarks-container">
    <v-menu
      bottom
      offset-y
      :close-on-content-click="true"
      :close-on-click="false"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          id="open-bookmarks"
          class="round-btn"
          :class="{ 'menu-closed': !isOpen }"
          rounded
          dark
          v-bind="attrs"
          v-on="on"
          @click="toggleBookmarks"
        >
          <div class="btn-content">
            <v-icon dark>mdi-bookmark-outline</v-icon>
            <span v-if="showBookmarks">{{ $t('device.filter.bookmarks') }}</span>
            <span v-if="showBookmarks" class="bracket">{{ $t('device.filter.bookmark_code') }}</span>
          </div>
        </v-btn>
      </template>
      <v-list class="scrollable-list">
        <v-list-item
          v-for="(bookmark, index) in getBookmarks.group"
          :id="`bookmark-${index}`"
          :key="index"
          class="d-flex justify-space-between"
          @click="selectBookmark(bookmark)"
        >
          <span v-if="getBookmarks.length === 0">{{ $t('device.filter.no_bookmarks') }}</span>
          <span v-else>{{ bookmark.name }}</span><v-icon :id="`delete-bookmark-${index}`" @click.stop="deleteBookmark(bookmark.id)">mdi-delete-outline</v-icon>
        </v-list-item>
      </v-list>
    </v-menu>
    <Notification
      :content="notificationContent"
      :type="notificationStatus"
      :isNotificationOpen="isNotificationOpen"
      @notificationClosed="closeNotification"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import useStore from '@/utils/store/common';
import { FilterGroup } from 'ctp-filter-group-management';
import Notification from '@/components/common/Notification/Notification.vue';
import './styles/filter-bookmarks.scss';

const store = useStore();
const emit = defineEmits(['applyBookmark']);
const showBookmarks = ref(false);

const getBookmarks = computed(() => store.getters['groupManagement/getGroups']);
const masterAccount = computed(() => store.getters['user/getSelectedMasterAccount']);
const isOpen = computed(() => showBookmarks.value);

const notificationContent = ref('');
const notificationStatus = ref('');
const isNotificationOpen = ref(false);

watch(masterAccount, (newMaster) => {
  if (newMaster && newMaster.id > 0) {
    store.dispatch('groupManagement/fetchFilterGroups');
  }
}, { immediate: true });

function toggleBookmarks() {
  showBookmarks.value = !showBookmarks.value;
}

function selectBookmark(bookmark: FilterGroup) {
  toggleBookmarks();
  emit('applyBookmark', bookmark);
}

async function deleteBookmark(id: string) {
  const res = await store.dispatch('groupManagement/deleteFilterGroup', [parseInt(id, 10)]);
  store.dispatch('groupManagement/fetchFilterGroups');
  notificationStatus.value = res.notificationStatus;
  notificationContent.value = res.notificationStatus;
  isNotificationOpen.value = true;
}

function closeNotification() {
  isNotificationOpen.value = false;
  notificationContent.value = '';
  notificationStatus.value = '';
}

</script>
